<template>
  <div class="w-100">
    <div v-if="title">
      <span class="atom-file-input__title">{{ title }}</span>
      <span v-if="isAsterisk" class="atom-file-input__asterisk">*</span>
      <span class="atom-file-input__title ml-1">{{ subTitle }}</span>
    </div>

    <!-- NOTE input for trigger file explorer  -->
    <div class="d-none">
      <b-form-file
        v-model="fileAttachment"
        multiple
        :id="id"
        :disabled="isDisable"
        :state="stateError"
      ></b-form-file>
    </div>

    <!-- NOTE display button and file list -->
    <div
      class="custom-file-input__container"
      :class="{ 'd-flex flex-column': isFlexColumn }"
    >
      <div class="button-section">
        <atom-button
          buttonId="select-file-button"
          buttonColor="secondary"
          buttonStyle="border"
          :isDisable="isDisable"
          @click="clickSelectFile"
        >
          <span class="button-text">Select File</span>
        </atom-button>
      </div>
      <div class="file-list-section" :class="{ 'error-border': isError }">
        <div
          v-for="(file, index) in fileAttachment"
          :key="index"
          class="custom-badge"
        >
          <span class="custom-text-break">{{ file.name }}</span>
          <div @click="clickDeleteFile(index)">
            <feather-icon
              icon="XIcon"
              class="custom-margin--icon delete-file-icon"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- NOTE error message -->
    <div v-if="isError && errorMessage" class="atom-file-input--error-text">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import { BFormFile } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
export default {
  name: "AtomFileAttachmentInput",
  components: {
    AtomButton,
    BFormFile,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    subTitle: {
      type: String,
      required: false,
      default: "",
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isError: {
      type: Boolean,
      required: false,
      default: null,
    },
    isAsterisk: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMessage: {
      type: String,
      required: false,
      default: "",
    },
    forceClearFileValue: {
      type: Number,
      required: false,
      default: 0,
    },
    isFlexColumn: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      fileAttachment: [],
    }
  },

  computed: {
    stateError() {
      /**
       * ? Red border at input will show when state is "false", therefore if error return "false", otherwise return "null" (normal state)
       * ? Remarks: state "true" is Green border at input
       */
      return this.isError ? false : null
    },
  },

  watch: {
    fileAttachment: {
      deep: true,
      handler() {
        this.$emit("onUpdateFile", this.fileAttachment)
      },
    },

    forceClearFileValue() {
      this.fileAttachment = []
    },
  },

  methods: {
    clickSelectFile() {
      document.getElementById(this.id).click()
    },

    clickDeleteFile(index) {
      this.fileAttachment.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
.atom-file-input__title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}

.atom-file-input__asterisk {
  color: #ea5455;
  font-size: 12px;
  margin-bottom: 0;
}

.atom-file-input--error-text {
  color: #ea5455;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.5;
}

.custom-file-input__container {
  display: grid;
  grid-template-areas: " button-section file-list-section";
  grid-template-columns: max-content auto;
  grid-template-rows: auto;
  grid-gap: 15px;
  margin-top: 8px;
}

.button-section {
  grid-area: button-section;
  display: flex;
  height: fit-content;
}

.file-list-section {
  grid-area: file-list-section;
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  width: 100%;
  border: 1px dashed #b9b9c3;
  border-radius: 5px;
  min-height: 38px;
}

.custom-badge {
  display: flex;
  background-color: #f0f1f1;
  border-radius: 4px;
  padding: 1px 9px;
  color: #82868b;
  font-weight: 600;
  font-size: 12px;
  width: fit-content;
  margin: 5px 10px 5px 0;
}

.custom-text-break {
  word-break: break-word;
}

.custom-margin--icon {
  margin-left: 5px;
}

.delete-file-icon:hover {
  cursor: pointer;
}

.error-border {
  border: 1px dashed #ea5455;
}
</style>
